"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = require("bignumber.js");
const emptyTokenApproval = {
    id: '0x',
    token: {
        id: '0x',
    },
    owner: '0x',
    spender: '0x',
    value: '0',
    valueExact: '0',
};
class TokenApproval {
    constructor(data) {
        this.data = data;
        if (!data) {
            this.data = emptyTokenApproval;
        }
    }
    get token() {
        return this.data.token.id;
    }
    get owner() {
        return this.data.owner;
    }
    get spender() {
        return this.data.spender;
    }
    get value() {
        return new bignumber_js_1.BigNumber(this.data.value);
    }
}
exports.default = TokenApproval;
//# sourceMappingURL=TokenApproval.js.map